import { createSelectors } from '@leverege/ui-redux';
import Constants from './Constants.js';
const initialState = {
  // resource : { action : true | false }
};

// eslint-disable-next-line default-param-last
function allowed(state = initialState, action) {
  switch (action.type) {
    case Constants.ALLOWED_SET:
      {
        const {
          resourceId,
          action: act,
          allowed
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = nState[resourceId] == null ? {} : {
          ...nState[resourceId]
        };
        nState[resourceId][act] = allowed;
        return nState;
      }
    default:
      return state;
  }
}
const EMPTY = Object.freeze({});
function get(state, resourceId) {
  return state?.[resourceId] || EMPTY;
}
function isAllowed(state, resourceId, action) {
  return state?.[resourceId]?.[action] === true;
}
allowed.get = get;
allowed.isAllowed = isAllowed;
allowed.createSelectors = (key, createSetStateKey = false) => {
  return createSelectors(key, {
    get,
    isAllowed
  }, createSetStateKey);
};

// Set up initial defaults to make methods available immediately with default state key
const selectors = allowed.createSelectors('allowed', true);
Object.keys(selectors).forEach(key => {
  allowed[key] = selectors[key];
});
export default allowed;